/**
 * Product hero / media collage hover intent.
 *
 * A `.pcm-product-mockup` / `.pcm-media-collage` group can have pieces that
 * overlap - a "front" card mostly covering a "back" card that only peeks out
 * along one edge. Sweeping the pointer across the whole group crosses that
 * front/back boundary, sometimes several times a second. Driving the "bring
 * to front" emphasis off plain CSS `:hover` meant every one of those
 * crossings restarted the hover transition, which read as a flicker right
 * at the top of the page.
 *
 * Instead, this only marks a piece `.is-active` once the pointer has
 * stayed on it continuously for SETTLE_MS - a quick pass-through never
 * commits. Leaving a piece waits CLEAR_MS before dropping `.is-active`, so
 * a momentary gap while crossing from one piece to another (or a couple of
 * pixels of gap between pieces) doesn't cause a flash of "nothing active"
 * in between. The actual "rise and gain shadow" animation is a slow CSS
 * transition on `.is-active` (see _product-hero.scss / _media-collage.scss);
 * this file only decides when that class should be on or off.
 */
(function () {
    'use strict';

    var SETTLE_MS = 90;
    var CLEAR_MS = 120;

    function initGroup(container) {
        var pieces = container.querySelectorAll('.pcm-product-mockup__piece, .pcm-media-collage__piece');

        if (!pieces.length) {
            return;
        }

        var activePiece = null;
        var pendingPiece = null;
        var settleTimer = null;

        function commit(piece) {
            if (activePiece === piece) {
                return;
            }

            if (activePiece) {
                activePiece.classList.remove('is-active');
            }

            activePiece = piece;

            if (activePiece) {
                activePiece.classList.add('is-active');
            }
        }

        function scheduleCommit(piece) {
            pendingPiece = piece;
            window.clearTimeout(settleTimer);
            settleTimer = window.setTimeout(function () {
                if (pendingPiece === piece) {
                    commit(piece);
                }
            }, piece ? SETTLE_MS : CLEAR_MS);
        }

        function onPieceEnter(piece) {
            scheduleCommit(piece);
        }

        function onPieceLeave(piece) {
            if (pendingPiece === piece) {
                scheduleCommit(null);
            }
        }

        for (var i = 0; i < pieces.length; i++) {
            (function (piece) {
                piece.addEventListener('mouseenter', function () {
                    onPieceEnter(piece);
                });
                piece.addEventListener('mouseleave', function () {
                    onPieceLeave(piece);
                });
            })(pieces[i]);
        }

        container.addEventListener('mouseleave', function () {
            window.clearTimeout(settleTimer);
            pendingPiece = null;
            commit(null);
        });
    }

    function init() {
        var groups = document.querySelectorAll('.pcm-product-mockup, .pcm-media-collage');

        for (var i = 0; i < groups.length; i++) {
            initGroup(groups[i]);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
